var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPropertyIconApartment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "translate(312 773)",
    fill: "red"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-312 -773)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.719,2A2.229,2.229,0,0,0,4.5,4.219V17.132a1.018,1.018,0,0,0,1.009,1.009H8.737a1.018,1.018,0,0,0,1.009-1.009V15.518a.193.193,0,0,1,.2-.2h1.211a.193.193,0,0,1,.2.2v1.614a1.018,1.018,0,0,0,1.009,1.009H15.6a1.018,1.018,0,0,0,1.009-1.009V4.219A2.229,2.229,0,0,0,14.386,2Zm0,1.211h7.667a1,1,0,0,1,1.009,1.009V16.93H12.57V15.518a1.422,1.422,0,0,0-1.412-1.412H9.947a1.422,1.422,0,0,0-1.412,1.412V16.93H5.711V4.219A1,1,0,0,1,6.719,3.211Zm.807,1.211a.605.605,0,1,0,0,1.211h.4a.605.605,0,1,0,0-1.211Zm2.825,0a.605.605,0,1,0,0,1.211h.4a.605.605,0,1,0,0-1.211Zm2.825,0a.605.605,0,1,0,0,1.211h.4a.605.605,0,1,0,0-1.211ZM7.526,6.842a.605.605,0,1,0,0,1.211h.4a.605.605,0,1,0,0-1.211Zm2.825,0a.605.605,0,1,0,0,1.211h.4a.605.605,0,1,0,0-1.211Zm2.825,0a.605.605,0,1,0,0,1.211h.4a.605.605,0,1,0,0-1.211ZM7.526,9.263a.605.605,0,1,0,0,1.211h.4a.605.605,0,1,0,0-1.211Zm2.825,0a.605.605,0,1,0,0,1.211h.4a.605.605,0,1,0,0-1.211Zm2.825,0a.605.605,0,1,0,0,1.211h.4a.605.605,0,1,0,0-1.211ZM7.526,11.684a.605.605,0,1,0,0,1.211h.4a.605.605,0,1,0,0-1.211Zm2.825,0a.605.605,0,1,0,0,1.211h.4a.605.605,0,1,0,0-1.211Zm2.825,0a.605.605,0,1,0,0,1.211h.4a.605.605,0,1,0,0-1.211Z",
    transform: "translate(311.5 773)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertyIconApartment);
export default __webpack_public_path__ + "static/media/property-icon-apartment.ed13b74360c7dd508b78c6c2186854b0.svg";
export { ForwardRef as ReactComponent };